module.exports = __webpack_public_path__ + "img/section_3_model.dac8f01b.png";